import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import { Tip } from "~/components/tip";
import type { FC } from "react";
import { Dialog } from "~/components/dialog";
import { Checkbox, FormControlLabel, IconButton, MenuItem } from "@mui/material";
import { useGetProcessesCache } from "~/queries/useGetProcesses";
import Grid from "@mui/system/Unstable_Grid";
interface ProcessFilterDialogProps {
  selectedProcesses: string[];
  hideProcess: (processId: string) => void;
  unhideProcess: (processId: string) => void;
  onClose: () => void;
}
export const ProcessFilterDialog: FC<ProcessFilterDialogProps> = props => {
  const {
    selectedProcesses,
    hideProcess,
    unhideProcess,
    onClose
  } = props;
  const {
    data: processes = []
  } = useGetProcessesCache();
  return <Dialog dialogProps={{
    maxWidth: "md"
  }} title={<Stack alignItems="center" direction="row" justifyContent="space-between" spacing={3}>
					<Typography variant="h6">Hide Processes</Typography>
					<IconButton color="inherit" onClick={onClose}>
						<SvgIcon>
							<XIcon />
						</SvgIcon>
					</IconButton>
				</Stack>} content={<>
					<Tip message={`Uncheck processes to hide process from list`} />
					<Box sx={{
      mt: 3
    }}>
						<Grid container>
							{processes.map(process => <Grid key={process.name} xs={6}>
									<MenuItem key={process.name}>
										<FormControlLabel control={<Checkbox checked={!(selectedProcesses ?? []).includes(process._id)} onChange={e => {
              if (!e.target.checked === true) {
                return void hideProcess(e.target.value);
              }
              return void unhideProcess(e.target.value);
            }} value={process._id} />} label={process.name} sx={{
              flexGrow: 1,
              mr: 0
            }} />
									</MenuItem>
								</Grid>)}
						</Grid>
					</Box>
				</>} data-sentry-element="Dialog" data-sentry-component="ProcessFilterDialog" data-sentry-source-file="process-filter-dialog.tsx" />;
};